import React, { useState, useEffect } from "react";
import Leftbar from "../../components/Leftsidebar";
import Topbar from "../../components/Topbar";
import { Link } from "react-router-dom";
import "../Projects/project.css";
import { getNotifications, resendNoti, usTimezone } from "../Utils/utils";
import ReactPaginate from "react-paginate";
import { Row, Col } from "react-bootstrap";
import Loaderspinner from "../../components/Loader";
import { showToast } from "../Utils/utils";
import { Tooltip } from "react-tooltip";

const Notifications = () => {
    const [showSidebar, setShowSidebar] = useState(false);
    const [projectList, setProjectList] = useState([]);
    const [page, setPage] = useState(0);
    const [totalPages, setTotalPages] = useState(1);
    const [loading, setLoading] = useState(false);
    const [search, setSearch] = useState("");

    const role = localStorage.getItem("role")

    const handleSidebar = () => setShowSidebar(!showSidebar);
    const handleSidebarClose = () => setShowSidebar(false);

    const fetchNotifications = async () => {
        try {
            setLoading(true);
            const token = localStorage.getItem("token");
            const limit = 10;
            const offset = page * limit;

            const response = await getNotifications({
                limit,
                offset,
                token,
                search,
            });

            setProjectList(response?.data || []);

            if ((response?.data?.length || 0) < limit) {
                setTotalPages(page + 1);
            } else {
                setTotalPages(page + 2);
            }
        } catch (error) {
            console.error("Error fetching notifications:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (search.length === 0 || search.length > 3) {
            fetchNotifications();
        }
    }, [page, search]);

    const onResend = async (id) => {
        const res = await resendNoti(id);
        showToast(res.message, "success");
    };

    return (
        <>
            {loading && <Loaderspinner />}

            <div className="g-sidenav-show bg-gray-100">
                <div id="wrapper">
                    <Leftbar
                        showSidebar={showSidebar}
                        handleSidebarClose={handleSidebarClose}
                    />

                    <main className="main-content border-radius-lg">
                        <Topbar handleSidebar={handleSidebar} />

                        {/* Header */}
                        <div className="header header-bg pb-6">
                            <div className="container-fluid">
                                <div className="header-body">
                                    <div className="row align-items-center py-4">
                                        <div className="col-lg-6 col-7">
                                            <nav
                                                aria-label="breadcrumb"
                                                className="d-none d-md-inline-block ml-md-4"
                                            >
                                                <ol
                                                    className="breadcrumb breadcrumb-links breadcrumb-dark"
                                                    style={{ background: "transparent" }}
                                                >
                                                    <li className="breadcrumb-item">
                                                        <Link to="/dashboard">
                                                            <i className="fas fa-home" />
                                                        </Link>
                                                    </li>
                                                    <li className="breadcrumb-item mt-2">
                                                        <span style={{ color: "#f6f9fc" }}>
                                                            Notifications
                                                        </span>
                                                    </li>
                                                </ol>
                                            </nav>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Content */}
                        <div className="container-fluid mt--6">
                            <div className="row">
                                <div className="col">
                                    <div className="card">
                                        <div className="card-header border-0">
                                            <div className="d-flex justify-content-between align-items-center">
                                                <div className="d-flex align-items-center" style={{ gap: '4px' }}>
                                                    <h5 className="mb-0 mr-2">Notifications</h5>
                                                    <span
                                                        data-tooltip-id="info-tooltip"
                                                        data-tooltip-content="List of all notifications sent to users."
                                                    >
                                                        <i className="fas fa-info-circle" />
                                                    </span>
                                                    <Tooltip id="info-tooltip" />
                                                </div>

                                                <div className="d-flex align-items-center " style={{ gap: '10px' }}>
                                                    <input
                                                        className="form-control mr-3"
                                                        style={{ width: "220px", borderRadius: "40px" }}
                                                        placeholder="Search"
                                                        value={search}
                                                        onChange={(e) => setSearch(e.target.value)}
                                                    />
                                                    {role !== "virtual_assistant" &&
                                                        <button
                                                            className="export-btn"
                                                            onClick={() =>
                                                                (window.location.href = "/send-notification")
                                                            }
                                                        >
                                                            Make New Notification
                                                        </button>
                                                    }
                                                </div>
                                            </div>
                                        </div>

                                        {/* Table */}
                                        <div className="table-responsive">
                                            <table className="table table-flush table-fixed">
                                                <thead className="thead-light">
                                                    <tr>
                                                        <th>Title</th>
                                                        <th>Description</th>
                                                        <th>No. of users</th>
                                                        <th>Sent on</th>
                                                        {role !== "virtual_assistant" &&
                                                            <th>Action</th>
                                                        }
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    {projectList.length > 0 ? (
                                                        projectList.map((project, index) => (
                                                            <tr key={index}>
                                                                <td title={project?.title}>
                                                                    {project?.title}
                                                                </td>

                                                                <td
                                                                    className="table-desc"
                                                                    title={project?.body}
                                                                >
                                                                    {project?.body}
                                                                </td>

                                                                <td>{project?.push_notification_users}</td>

                                                                <td>{usTimezone(project?.created_at)}</td>
                                                                {role !== "virtual_assistant" &&
                                                                    <td className="table-action">
                                                                        <button
                                                                            className="viewproject-btn"
                                                                            onClick={() => onResend(project?.id)}
                                                                        >
                                                                            Send Again
                                                                        </button>
                                                                    </td>
                                                                }
                                                            </tr>
                                                        ))
                                                    ) : (
                                                        <tr>
                                                            <td colSpan="5" className="text-center">
                                                                <b>No records found</b>
                                                            </td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Pagination */}
                            <Row>
                                <Col xs={12}>
                                    <div className="paginate-css">
                                        <ReactPaginate
                                            previousLabel="<"
                                            nextLabel=">"
                                            breakLabel="..."
                                            pageCount={totalPages}
                                            marginPagesDisplayed={1}
                                            pageRangeDisplayed={2}
                                            onPageChange={({ selected }) => setPage(selected)}
                                            containerClassName="pagination"
                                            activeClassName="active"
                                        />
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </main>
                </div>
            </div>
        </>
    );
};

export default Notifications;
